import React, { useEffect, useState } from "react";
import "../css/main.css";
import "../css/dashboard.css";
import { useNavigate } from "react-router-dom";
import UserList from "./UserList";
import UserModal from "./UserModal";
import {apiRequest, getUsers} from "../api";
import Sidebar from "./Sidebar";
import { isUniAdmin } from "../utils/roleUtils";

const UniAdminDashboard = () => {
    const [numbers, setNumbers] = useState([]);
    const [error, setError] = useState(null);
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [showUserModal, setShowUserModal] = useState(false);
    const apiUrl = process.env.REACT_APP_API_BASE_URL;

    const firstName = localStorage.getItem("firstName");
    const universityId = localStorage.getItem("universityId");
    const navigate = useNavigate();

    // Logout handler
    const handleLogout = (event) => {
        event.preventDefault();
        console.log("Navigating to /login...");
        localStorage.clear();
        navigate("/login");
    };

    // Fetch dashboard numbers
    useEffect(() => {
        if (universityId) {
            const token = localStorage.getItem('token');
            
            fetch(`${apiUrl}/dashboard/${universityId}/numbers`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Failed to fetch numbers");
                    }
                    return response.json();
                })
                .then((data) => {
                    console.log("Dashboard numbers:", data);
                    setNumbers(data);
                })
                .catch((error) => {
                    console.error("Error fetching numbers:", error);
                    setError("Failed to load statistics. Please try again.");
                });
        }
    }, [universityId]);

    // Add user handler
    const handleAddUser = () => {
        setSelectedUser(null);
        setShowUserModal(true);
    };

    // Edit user handler
    const handleEditUser = (user) => {
        setSelectedUser(user);
        setShowUserModal(true);
    };

    // Save user handler
    const handleSaveUser = async () => {
        setShowUserModal(false);
        const token = localStorage.getItem("token");

        try {
            const endpoint = `${apiUrl}/users`;
            const users = await apiRequest(endpoint, "GET", null, token);
            setUsers(users);
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    return (
        <div className="dashboard">
            <Sidebar />
            <main className="main-content">
                <header className="header">
                    <h3>Welcome back, {firstName}!</h3>
                    <h4>Overview</h4>
                    <hr />
                    <div className="overview">
                        <div className="overview-item"><h2>{numbers[0] || 0}</h2><p>Tours</p></div>
                        <div className="overview-item"><h2>{numbers[1] || 0}</h2><p>Events</p></div>
                        <div className="overview-item"><h2>{numbers[2] || 0}</h2><p>Submissions</p></div>
                    </div>
                </header>

                <section className="quick-actions" style={{ marginTop: "40px", marginBottom: "40px" }}>
                    <h4>Quick Actions</h4>
                    <hr />
                    <div className="actions">
                        <button onClick={handleAddUser} className="action-button new-event">
                            <i className="fa fa-user" aria-hidden="true"></i> + New User
                        </button>
                        <a href="/tours" className="action-button new-tour">
                            <i className="fa fa-map" aria-hidden="true"></i> Manage Tours
                        </a>
                        <a href="/forms" className="action-button new-form">
                            <i className="fa fa-sticky-note" aria-hidden="true"></i> Manage Forms
                        </a>
                    </div>
                </section>

                {showUserModal && (
                    <UserModal
                        user={selectedUser}
                        onClose={() => setShowUserModal(false)}
                        onSave={handleSaveUser}
                    />
                )}
            </main>
        </div>
    );
};

export default UniAdminDashboard; 